import { cn } from '~utils/cn'

import resourceUriDecorate, { RequiredWidth } from '~utils/resource-uri-decorator'
import { AVATAR_SIZE_CSS, AvatarProps } from './types'

/**
 * @version v1.1.3
 * @author Danny
 * @description parent element's position, width, height 관련 console warning 뜨던 라인 fix
 */
const Avatar = ({ uri, alt = 'thumbnail', size = '40', className }: AvatarProps) => {
  return (
    <div
      className={cn(
        'relative shrink-0 overflow-hidden rounded-full border border-solid border-gray-200 bg-gray-300',
        AVATAR_SIZE_CSS[size],
        className
      )}
    >
      <img
        src={resourceUriDecorate(uri, {
          width: RequiredWidth.W150,
        })}
        alt={alt}
        style={{
          objectFit: 'cover',
        }}
      />
    </div>
  )
}

export default Avatar
